import React from "react";
import cx from "classnames";

const FormWrapper = ({ title, children, className }) => (
  <div className={cx("px-20 pt-40 pb-24 lg:pt-20 lg:px-40", className)}>
    <h2 className="text-26-36 text-gray-text font-semibold text-center lg:text-left mb-24">
      {title}
    </h2>
    <div className="flex flex-col space-y-45">{children}</div>
  </div>
);
FormWrapper.defaultProps = {
  title: "",
  className: "",
};

export default FormWrapper;
